export const getCollection = (payload, keys = []) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  const fallbackKeys = ['data', 'items', 'records', 'responses'];

  for (const key of [...keys, ...fallbackKeys]) {
    if (Array.isArray(payload?.[key])) {
      return payload[key];
    }
  }

  return [];
};

export const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(key, String(item));
        }
      });
      return;
    }

    searchParams.append(key, String(value));
  });

  return searchParams.toString();
};
